import { EligibilityCheckResult } from 'domains/signupv4/Insurance/types';

export const canShowPCPSection = (
  insuranceType: string,
  isPCPRequired: boolean,
  eligibilityCheckResult?: EligibilityCheckResult,
) => {
  if (!isPCPRequired) return false;
  
  // For Medicaid: show PCP section for actual eligibility results (successful or with null PCP data)
  if (insuranceType === 'Medicaid') {
    const isActualEligibilityResult = eligibilityCheckResult === EligibilityCheckResult.IN_NETWORK ||
                                     eligibilityCheckResult === EligibilityCheckResult.OUT_OF_NETWORK ||
                                     eligibilityCheckResult === EligibilityCheckResult.INACTIVE;
    
    // Show PCP section when:
    // 1. We have actual eligibility results (not request failures)
    // 2. Regardless of whether PCP data was found or not (eligibilityHasPCP can be true or false)
    return isActualEligibilityResult;
  }

  // For Medicare/Commercial: show immediately if PCP is required
  return true;
};
